import { API_BASE } from '@/services/api/config'

type LocationLike = Pick<Location, 'protocol' | 'hostname' | 'port'>

export function getDjangoOrigin(location: LocationLike = window.location) {
  const configuredOrigin = import.meta.env.VITE_DJANGO_BASE_URL
  if (configuredOrigin) {
    return new URL(configuredOrigin, window.location.origin).origin
  }

  if (location.port === '3000') {
    return `${location.protocol}//${location.hostname}:8001`
  }

  if (location.hostname === 'web.beoflow.com') {
    return 'https://app.beoflow.com'
  }

  if (location.hostname === 'staging.beoflow.com') {
    return `${location.protocol}//${location.hostname}`
  }

  // Anywhere else -- a Cloudflare Pages branch preview, most of all -- follow the
  // API. The two are the same host in every environment, and a preview already
  // talks to the production backend for everything else. Without this the origin
  // was empty, so a Django link resolved against the PREVIEW's own origin: the
  // SPA answers 200 with index.html for any path, so "Sync data" opened a new tab
  // straight back into the webapp instead of the sync page, with no error to see.
  // Only an ABSOLUTE base names a host. A relative one ("/api/v1") means the API
  // is same-origin, which is what the empty return below already says.
  if (API_BASE) {
    try {
      return new URL(API_BASE).origin
    } catch {
      // Relative or malformed: fall through to same origin.
    }
  }

  return ''
}
